  <template>
  <div class="fade-in-fwd my-project-modal">
    <div class="fade-in-fwd mt-2">
      <div class="row">
        <div class="col-sm-12">
          <label for="">{{ $resourceString["myProject.Project.AddItemModal.ProductStep1.ProjectGridSize.Label"] }}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <my-project-radio-field :options="getContentWizardData.radioOptions" name="size" v-model="getContentItem.size"></my-project-radio-field>
        </div>
      </div>
      <div class="form-group mt-2">
        <label for="#Step2Description" class="gray-bold"
          >
          {{ $resourceString["contentWizard.GalleryImages.ImageDescription.Label"] }}
          <span class="optional-field ml-3"> {{ $resourceString["contentWizard.Label.Field.Optional"] }} </span>
          </label
        >
        <my-project-description-field customClass="form-control"  maxlength="400" fieldId="description" :placeholder="$resourceString['myProject.ProductItem.Description.Placeholder']" v-model="getContentItem.description" ></my-project-description-field>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import myProjectRadioField from "../../../my-projects-page/my-project-radio-field.vue";
import myProjectDescriptionField from "../../../my-projects-page/my-project-description-field.vue";
export default {
  props: ["projectID", "productData"],
  components:{
    myProjectRadioField,
    myProjectDescriptionField
  },
  computed: {
    ...mapGetters({
      getContentWizardData: "contentWizard/getContentWizardData",
      getisProductSearchDisabled: "contentWizard/getisProductSearchDisabled",
      getproductSearchResponse: "contentWizard/getproductSearchResponse",
      getFilterForProductSearch: "contentWizard/getFilterForProductSearch",
      getContentItem:"contentWizard/getContentItem"
    }),
    getSteps() {
      return this.getContentWizardData.step;
    }
  },

  methods: {
    ...mapActions({
      updateProductItem: "myProject/updateProductItem",
      resourceString: "myProject/resourceString",
      projectAlreadyExistResourceString:
        "myProject/projectAlreadyExistResourceString"
    }),

    hideModal(name) {
      this.$modal.hide(name + "-modal");
    },

    closeModal() {
      this.hideModal("project-edit-content-item");
    }
  }
};
</script>
